module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/_library.js
// module id = 289
// module chunks = 0